import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class PullRequestsService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Get all Pull Requests by organization and project IDs
     * @returns PullRequestList OK.
     * @throws ApiError
     */
    listPullRequests({ orgId, projectId, after, before, sort = '-id', filter, limit = 10, page = 1, pageSize = 10, search, status = 'OPEN', reviewStatus, createdById, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-requests', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
                'page': page,
                'pageSize': pageSize,
                'search': search,
                'status': status,
                'reviewStatus': reviewStatus,
                'createdById': createdById,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create new Pull Request
     * @returns PullRequest New pull request created.
     * @throws ApiError
     */
    createPullRequest({ orgId, projectId, requestBody, cookie, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/pull-requests', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, headers: {
                'cookie': cookie,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get Pull Request by Id or Number
     * @returns PullRequest OK.
     * @throws ApiError
     */
    getPullRequest({ orgId, projectId, idOrNumber, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{idOrNumber}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'idOrNumber': idOrNumber,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update pull request
     * @returns PullRequest OK.
     * @throws ApiError
     */
    updatePullRequest({ orgId, projectId, idOrNumber, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{idOrNumber}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'idOrNumber': idOrNumber,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete pull request
     * @returns void
     * @throws ApiError
     */
    deletePullRequest({ orgId, projectId, idOrNumber, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{idOrNumber}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'idOrNumber': idOrNumber,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get Pull Request by branch name
     * @returns PullRequest OK.
     * @throws ApiError
     */
    getPullRequestByBranchName({ orgId, projectId, branchName, filter, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{branchName}/branch', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
            }, query: {
                'filter': filter,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update pull request branch
     * @returns PullRequest OK.
     * @throws ApiError
     */
    updatePullRequestBranch({ orgId, projectId, branchName, requestBody, cookie, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{branchName}/branch', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
            }, headers: {
                'cookie': cookie,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get pull request diff
     * @returns string OK.
     * @throws ApiError
     */
    getPullRequestDiff({ orgId, projectId, idOrNumber, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{idOrNumber}/diff', path: {
                'orgId': orgId,
                'projectId': projectId,
                'idOrNumber': idOrNumber,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get pull request checks
     * @returns CommitStatus OK.
     * @throws ApiError
     */
    getPullRequestChecks({ orgId, projectId, number, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{number}/checks', path: {
                'orgId': orgId,
                'projectId': projectId,
                'number': number,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get pull requests merge conflicts
     * @returns MergeConflicts OK.
     * @throws ApiError
     */
    getPullRequestMergeConflicts({ orgId, projectId, branchName, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{branchName}/merge-conflicts', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get Reviews
     * @returns ReviewList OK.
     * @throws ApiError
     */
    listReviews({ orgId, projectId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-request-reviews', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create Review
     * @returns Review OK.
     * @throws ApiError
     */
    createReview({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/pull-request-reviews', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get Review by ID
     * @returns Review OK.
     * @throws ApiError
     */
    getReview({ orgId, projectId, reviewId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-request-reviews/{reviewId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'reviewId': reviewId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update Review by ID
     * @returns Review OK.
     * @throws ApiError
     */
    updateReview({ orgId, projectId, reviewId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/pull-request-reviews/{reviewId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'reviewId': reviewId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete Review by ID
     * @returns void
     * @throws ApiError
     */
    deleteReview({ orgId, projectId, reviewId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/pull-request-reviews/{reviewId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'reviewId': reviewId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get all Review Comments
     * @returns ReviewCommentList OK.
     * @throws ApiError
     */
    listReviewComments({ orgId, projectId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/review-comments', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create Review Comment
     * @returns ReviewComment OK.
     * @throws ApiError
     */
    createReviewComment({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/review-comments', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get Review Comment by ID
     * @returns ReviewComment OK.
     * @throws ApiError
     */
    getReviewComment({ orgId, projectId, commentId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/review-comments/{commentId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'commentId': commentId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update Review Comment by ID
     * @returns ReviewComment OK.
     * @throws ApiError
     */
    updateReviewComment({ orgId, projectId, commentId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/review-comments/{commentId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'commentId': commentId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete Review Comment by ID
     * @returns void
     * @throws ApiError
     */
    deleteReviewComment({ orgId, projectId, commentId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/review-comments/{commentId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'commentId': commentId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get if pull request can be merged
     * @returns CanMergePullRequest OK.
     * @throws ApiError
     */
    canMergePullRequest({ orgId, projectId, pullRequestId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{pullRequestId}/can-merge', path: {
                'orgId': orgId,
                'projectId': projectId,
                'pullRequestId': pullRequestId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create external review
     * @returns any OK.
     * @throws ApiError
     */
    createExternalReview({ orgId, projectId, pullRequestId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{pullRequestId}/external-review', path: {
                'orgId': orgId,
                'projectId': projectId,
                'pullRequestId': pullRequestId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Commit suggestions
     * @returns void
     * @throws ApiError
     */
    commitSuggestions({ orgId, projectId, pullRequestId, filePath, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/pull-requests/{pullRequestId}/files/{filePath}/commit-suggestions', path: {
                'orgId': orgId,
                'projectId': projectId,
                'pullRequestId': pullRequestId,
                'filePath': filePath,
            }, body: requestBody, mediaType: 'application/json', errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get pull requests reviewers
     * Get pull requests reviewers.
     * @returns ReviewerList OK.
     * @throws ApiError
     */
    listReviewers({ orgId, projectId, after, before, limit = 10, filter, search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-request-reviewers', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'search': search,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get all history events for Pull Request
     * @returns TimelineEventList OK.
     * @throws ApiError
     */
    listTimelineEvents({ orgId, projectId, after, before, sort = '-id', filter, limit = 10, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pull-request-timeline-events', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=PullRequestsService.js.map